import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { DataProvider } from './contexts/DataContext.jsx';
import './index.css';

// Disable console warnings in development
if (process.env.NODE_ENV === "development") {
  console.warn = () => {};
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <DataProvider>
      <App />
    </DataProvider>
  </StrictMode>
);